module.exports = __webpack_public_path__ + "img/test_d.1aa435a4.png";